export const defaultNCRInboxPaperTabIndex = 0;

export const NCRInboxPaperTabsIndex = {
    INFO_TAB: 0,
    ACTIVITY_TAB: 1,
};
